// components/LineChart.js
import React from "react";
import { Line } from "react-chartjs-2";

function LineChart({ chartData, title }) {
  return (
    <div className="chart-container">
      <Line
        data={chartData}
        options={{
          spanGaps: true,
          plugins: {
            title: {
              display: true
            },
            legend: {
              display: true
            }
          }
        }}
      />
    </div>
  );
}
export default LineChart;